<template>
  <div class="my-jobs-toggle">
    <p class="label text-textDarkest">
      {{ documentTypeLabel }}
    </p>
    <DpplSlimSwitch
      :disabled="isDisabled"
      :model-value="myJobsEnabled"
      @update:model-value="handleMyJobs"
    />
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useRoute, useRouter } from 'vue-router';
import { useFilters } from '@/stores/filters/filters';
import { computed } from 'vue';
import DpplSlimSwitch from '@/components/datapeople/DpplSlimSwitch.vue';

defineProps({
  isDisabled: { type: Boolean, default: false },
});

const emits = defineEmits(['filters-tracking-event']);

// Router
const router = useRouter();
const route = useRoute();

// Stores
const filtersStore = useFilters();
const { myJobsEnabled } = storeToRefs(filtersStore);
const { submitMyJobs } = filtersStore;

const documentTypeLabel = computed(() => {
  if (route.name === 'templates') return 'My Templates';
  if (route.name === 'draft-job-profiles') return 'My Job Profiles';
  if (route.name === 'approvals-library') return 'My Approvals';
  return 'My Jobs';
});

const handleMyJobs = ($event) => {
  emits('filters-tracking-event', {
    action: 'filterMyJobsClick',
    args: {
      enable: $event,
      page: route.name,
    },
  });

  // New Events in testing
  emits('filters-tracking-event', {
    action: 'appliedFilters',
    args: {
      page: route.name,
      filterTypes: ['My Jobs'],
      filterName: $event,
    },
  });

  submitMyJobs({ myJobsEnabled: $event, router });
};
</script>

<style lang="less" scoped>
.my-jobs-toggle {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px;

  .label {
    font-size: 13px;
    font-weight: 500;
  }
}
</style>
